// Users API service using generated OpenAPI client - HATEOAS style
import { apiCall } from './apiService'
import type { Api } from '../types/generated'

// Types that match the new HATEOAS API structure
export interface User extends Api.User {
  id: string
  href: string
  roles?: string[]
}

export interface UsersListResponse {
  users: User[]
  total: number
  page_size?: number
  page_number?: number
  page_previous?: string | null
  page_next?: string | null
}

export interface UsersQueryParams {
  name?: string[]
  role?: string[]
  page_size?: number
  page_number?: number
  sort?: string[]
}

export const usersApi = {
  // HATEOAS-style: Use the href from clinic.users.href instead of constructing URL
  async getUsers(usersHref: string, params?: UsersQueryParams): Promise<UsersListResponse> {
    // Build query params if provided
    let queryString = ''
    if (params) {
      const searchParams = new URLSearchParams()
      if (params.name) params.name.forEach(n => searchParams.append('name', n))
      if (params.role) params.role.forEach(r => searchParams.append('role', r))
      if (params.page_size) searchParams.set('page_size', params.page_size.toString())
      if (params.page_number) searchParams.set('page_number', params.page_number.toString())
      if (params.sort) params.sort.forEach(s => searchParams.append('sort', s))
      queryString = searchParams.toString() ? `?${searchParams.toString()}` : ''
    }
    
    const data = await apiCall(`${usersHref}${queryString}`)
    console.log('API returned data:', data)
    
    const result = {
      users: (data?.items || []).map((item: any) => ({
        ...item,
        id: item.id!,
        href: item.href!,
        roles: item.roles || []
      })),
      total: data?.total_items || 0,
      page_size: data?.page_size,
      page_number: data?.page_number,
      page_previous: data?.page_previous,
      page_next: data?.page_next,
    }
    
    console.log('Service returning:', result)
    console.log('Number of users:', result.users.length)
    
    return result
  },

  // HATEOAS-style: POST to the users href (which includes the clinic context)
  async createUser(usersHref: string, userData: Api.User): Promise<{ id: string; href: string }> {
    return await apiCall(usersHref, {
      method: 'POST',
      body: JSON.stringify(userData),
    })
  },

  // HATEOAS-style: Use the user's own href to get details
  async getUser(userHref: string): Promise<User> {
    const data = await apiCall(userHref)
    
    // Handle both single user and array responses
    const user = Array.isArray(data?.items) ? data.items[0] : data
    return {
      ...user,
      id: user?.id!,
      href: user?.href!,
      roles: user?.roles || []
    } as User
  },

  // HATEOAS-style: PATCH to the user's own href
  async updateUser(userHref: string, userData: Partial<Api.User>): Promise<{ id: string; status: string; message: string }> {
    return await apiCall(userHref, {
      method: 'PATCH',
      body: JSON.stringify(userData),
    })
  },

  // HATEOAS-style: DELETE to the user's own href
  async deleteUser(userHref: string): Promise<void> {
    await apiCall(userHref, {
      method: 'DELETE',
    })
  },
}